import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { remaining } from '@/lib/format';
import { cn } from '@/lib/cn';

/** Live handover clock. Green with time to spare, amber inside the last six
 *  hours, red once over. Ticks every minute. */
export default function Countdown({ due, label, className }: { due?: string | null; label?: string; className?: string }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = window.setInterval(() => setNow(Date.now()), 60_000); return () => window.clearInterval(t); }, []);
  const r = remaining(due, now);
  if (!r) return null;
  return (
    <span
      data-testid="countdown"
      title={due ? `Due ${new Date(due).toLocaleString()}` : undefined}
      className={cn('inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium tabular-nums',
        r.over ? 'border-red-500/50 bg-red-600/15 text-red-300'
          : r.soon ? 'border-amber-500/50 bg-amber-600/15 text-amber-300'
            : 'border-emerald-500/40 bg-emerald-600/10 text-emerald-300', className)}
    >
      <Clock size={10} /> {label ? `${label} ` : ''}{r.text}
    </span>
  );
}
